import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { ListLinks } from '../../../@core/constants/list-links';
import { PriceList } from '../../../generated/generated-types';
import { GenericBaseModelDropDown } from '../../../shared/components/genericBaseModelDropDown';
import { PriceListService } from '../../products/services/price-list.service';

@Component({
  selector: 'app-formly-field-product-price-list-drop-down',
  imports: [
    CommonModule,
    FormsModule,
    FormlyModule,
    ReactiveFormsModule
  ],
  template: '',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [PriceListService]
})
export class FormlyFieldProductPriceListDropDownComponent extends GenericBaseModelDropDown<PriceList> {

  constructor() {
    super(inject(PriceListService), "PriceList");
    this.listUrl.set(ListLinks.PRODUCT_PRICE);
  }


}
